import BaseApiServiceV2 from "./BaseApiServiceV2";

class GeoSearchServices extends BaseApiServiceV2 {
  /**
   * @param {String} id
   * @returns Promise<Object>
   * @memberof SearchService
   */

  geoSearch(keyword: string) {
    return this.apiGet(`/listing/geo-search?${keyword}`);
  }
  getFeaturedProperties(keyword: string) {
    return this.apiGet(`/property/featured?${keyword}`)
  }
  getCountryMaxPrice(keyword: string) {
    return this.apiGet(`/listing/highest-price${keyword}`)
  }
}
export default new GeoSearchServices();
